export default "/images/wm-customer.png";